import { CheckboxCheckedFilled, CheckboxIndeterminate, Checkbox as CheckboxOpen } from '@carbon/icons-react';
import { useTheme } from '@repo/theme';
import { HorizBox, HoverView, Pad, PadBox } from 'component/basics';
import { UtilityText } from 'component/text';
import { useState } from 'react';
import { View } from 'react-native-web';
import type { TLabel } from 'util/stdtypes';
import { makeTestID } from 'util/stdtypes';

type CheckboxProps = {
    emoji?: string;
    text?: string;
    label?: TLabel;
    value?: boolean;
    onChange?: (value: boolean) => void;
    size?: number;
    ariaLabel?: TLabel;
    testID?: string;
    indeterminate?: boolean;
    disabled?: boolean;
};

export function Checkbox({
    emoji,
    text,
    label,
    value = false,
    onChange,
    size = 32,
    ariaLabel,
    testID,
    indeterminate,
    disabled,
}: CheckboxProps) {
    const { colors } = useTheme();
    const [hover, setHover] = useState(false);

    return (
        <HoverView
            aria-checked={indeterminate ? 'mixed' : !!value}
            ariaLabel={ariaLabel}
            disabled={disabled}
            onHoverIn={() => setHover(true)}
            onHoverOut={() => setHover(false)}
            onPress={() => onChange?.(!value)}
            role='checkbox'
            testID={makeTestID({ testID, label, text })}
        >
            <PadBox vert={8}>
                <HorizBox center>
                    <View style={{ width: size }}>
                        {indeterminate ? (
                            <CheckboxIndeterminate color={disabled ? colors.colorBorderPrimary : colors.colorButtonPrimary} size={size} />
                        ) : value ? (
                            <CheckboxCheckedFilled color={disabled ? colors.colorBorderPrimary : colors.colorButtonPrimary} size={size} />
                        ) : (
                            <CheckboxOpen size={size} style={{ fill: hover ? colors.colorBorderSelected : colors.colorBorderPrimary }} />
                        )}
                    </View>
                    {text || label ? <Pad size={12} /> : null}
                    {emoji && (
                        <PadBox right={6}>
                            <UtilityText aria-hidden text={emoji} type='tiny' weight='strong' />
                        </PadBox>
                    )}
                    <UtilityText color={disabled ? colors.colorTextDisabled : colors.colorTextPrimary} label={label} text={text} />
                </HorizBox>
            </PadBox>
        </HoverView>
    );
}
